export default __webpack_public_path__ + "static/media/no-avatar.e9cc587a.jpg";